import get from "lodash/get";
import React from "react";
import { TFunction } from "i18next";

import { getNameSelection } from "~/libs/getData";
import {
  DEALER_OPTIONS_ROLE_SALES_USER,
  DEALER_OPTIONS_ROLE_SERVICE_USER,
} from "~/pages/Dealers/options";

export const mapDealerItem = (
  dealer: any,
  isEn: boolean,
  t: TFunction,
  addressKey: string,
) => {
  const managers = dealer.Users.reduce(
    (accumulator, user) => {
      const { role, fullname, fullnameEn } = get(user, "User", {});

      DEALER_OPTIONS_ROLE_SALES_USER.includes(role) &&
        accumulator.regionalSalesManager.push(
          <div>{isEn ? fullnameEn : fullname}</div>,
        );
      DEALER_OPTIONS_ROLE_SERVICE_USER.includes(role) &&
        accumulator.regionalServiceManager.push(
          <div>{isEn ? fullnameEn : fullname}</div>,
        );
      return accumulator;
    },
    { regionalSalesManager: [], regionalServiceManager: [] },
  );

  return {
    ...dealer,
    DealerName: getNameSelection("DealerName", dealer),
    country: getNameSelection("country", dealer),
    FO: getNameSelection("FO", dealer),
    subject: getNameSelection("subject", dealer),
    city: getNameSelection("city", dealer),
    address: getNameSelection(addressKey, dealer),
    type: getNameSelection("type", dealer),
    status: t(`dealersForm.${dealer.status}`),
    ...managers,
  };
};
